var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.373,
    height: 92.868,
    viewBox: "0 0 73.373 92.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32397",
    x: 0,
    y: 0,
    width: 73.373,
    height: 92.868,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32397-2",
    "data-name": "Path 32397",
    d: "M-2.87-39.008a18.066,18.066,0,0,1,9.229-2.074,24.984,24.984,0,0,1,12.288,3.007,22.552,22.552,0,0,1,8.607,8.3,23.379,23.379,0,0,1,3.163,12.236A25.685,25.685,0,0,1,26.891-4.218a25.478,25.478,0,0,1-9.8,9.436A29.368,29.368,0,0,1,2.626,8.692a29.878,29.878,0,0,1-14.1-3.266A25.324,25.324,0,0,1-21.328-3.6a24.069,24.069,0,0,1-3.629-13.117,32.171,32.171,0,0,1,2.748-12.6A66.345,66.345,0,0,1-13.447-43.57L1.174-62.65a8.272,8.272,0,0,1,6.844-3.526,10.013,10.013,0,0,1,7.362,3.007ZM2.522-1.574q7.051,0,11.407-4.252a14.814,14.814,0,0,0,4.355-11.1,14.814,14.814,0,0,0-4.355-11.1Q9.574-32.268,2.522-32.268A15.676,15.676,0,0,0-8.832-28.016a14.722,14.722,0,0,0-4.407,11.1,14.722,14.722,0,0,0,4.407,11.1A15.676,15.676,0,0,0,2.522-1.574Z",
    transform: "translate(33.96 72.18)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon6);
export default __webpack_public_path__ + "static/media/number-icon6.bf7670af6035f5f98bad9252d3865a30.svg";
export { ForwardRef as ReactComponent };